import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=0c46c05c&scoped=true&"
import script from "./BaseInputText.vue?vue&type=script&lang=js&"
export * from "./BaseInputText.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputText.vue?vue&type=style&index=0&id=0c46c05c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c46c05c",
  null
  
)

export default component.exports